import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';
import {textHandle} from 'presentation/utils/textHandle';

import {ExamCardType} from '../types';
import {EXAM_TYPE_OPTIONS} from '../constants';
import {useExamReportsStore} from 'presentation/modules/examResults/store/useExamReportsStore';

export const useExamCard = ({exam}: ExamCardType) => {
	const type = textHandle(exam.dsTipoExame).removeSpecialChar();
	const examType = EXAM_TYPE_OPTIONS[type as keyof typeof EXAM_TYPE_OPTIONS];
	const examDate = exam.dtPedido;

	const descriptionDate = formatDateString(
		examDate,
		DateFormatEnum.DATE_FORMAT_1,
		DateFormatEnum.DATE_FORMAT_1,
		'às',
	);
	const setExamRequestData = useExamReportsStore(state => state.setExamRequestData);

	const handleOpenExamDetails = () => {
		setExamRequestData(exam);
	};

	return {
		handleOpenExamDetails,
		descriptionDate,
		examType,
	};
};
